export const AGENT_SETUP_PROMPT_PATH = "/agent-setup/prompt.md" as const;
export const AGENT_SETUP_PROMPT_URL = "https://app.das.dev/agent-setup/prompt.md" as const;
export const AGENT_SETUP_COPY_PROMPT =
  "Fetch and execute the appropriate instructions to set me up for Delta Adaptive Systems from https://app.das.dev/agent-setup/prompt.md" as const;

export const AGENT_SETUP_RELEASE = {
  version: "0.7.1",
  artifactPath: "/agent-setup/releases/0.7.1/delta-adaptive-systems-mockups-0.7.1.tar",
  artifactUrl:
    "https://app.das.dev/agent-setup/releases/0.7.1/delta-adaptive-systems-mockups-0.7.1.tar",
  artifactBytes: 1_262_592,
  artifactSha256: "ebac5465fcc834c6f7631a023adc2f198ee867c90c42d824e31de8393280ed9f",
  manifestPath: "/agent-setup/releases/0.7.1/manifest.json",
  manifestUrl: "https://app.das.dev/agent-setup/releases/0.7.1/manifest.json",
  manifestBytes: 1_295,
  manifestSha256: "5ad63c41d106bd5f23ec031baebd975e72f95ded7d9f0d135cf8db8d3c14a6e5",
} as const;

export const AGENT_SETUP_RETAINED_RELEASES = [
  {
    version: "0.7.0",
    artifactPath: "/agent-setup/releases/0.7.0/delta-adaptive-systems-mockups-0.7.0.tar",
    artifactUrl:
      "https://app.das.dev/agent-setup/releases/0.7.0/delta-adaptive-systems-mockups-0.7.0.tar",
    artifactBytes: 1_260_032,
    artifactSha256: "d003b3aa3fcfc7eb5c18e76a973e5378884082577078649164fc95cf446a9939",
    manifestPath: "/agent-setup/releases/0.7.0/manifest.json",
    manifestUrl: "https://app.das.dev/agent-setup/releases/0.7.0/manifest.json",
    manifestBytes: 1_295,
    manifestSha256: "864c6953f87900ac2f1a2e974eed762af9146026e9d5011b7a829cf86d332772",
  },
  {
    version: "0.6.0",
    artifactPath: "/agent-setup/releases/0.6.0/delta-adaptive-systems-mockups-0.6.0.tar",
    artifactUrl:
      "https://app.das.dev/agent-setup/releases/0.6.0/delta-adaptive-systems-mockups-0.6.0.tar",
    artifactBytes: 1_230_336,
    artifactSha256: "94a85b226b9bfa38a47d53e04fb65560166dd869046a470318b41701238544e0",
    manifestPath: "/agent-setup/releases/0.6.0/manifest.json",
    manifestUrl: "https://app.das.dev/agent-setup/releases/0.6.0/manifest.json",
    manifestBytes: 1_255,
    manifestSha256: "8ef4b5b596bb5a8f57d7830de59c5324ae4a84c56270a9947e82116a98effb1d",
  },
  {
    version: "0.5.0",
    artifactPath: "/agent-setup/releases/0.5.0/delta-adaptive-systems-mockups-0.5.0.tar",
    artifactUrl:
      "https://app.das.dev/agent-setup/releases/0.5.0/delta-adaptive-systems-mockups-0.5.0.tar",
    artifactBytes: 1_204_736,
    artifactSha256: "8fe315bd6910647808e3f50808b5a5c40478f8d32d315f669d981b492d7baf22",
    manifestPath: "/agent-setup/releases/0.5.0/manifest.json",
    manifestUrl: "https://app.das.dev/agent-setup/releases/0.5.0/manifest.json",
    manifestBytes: 913,
    manifestSha256: "76bb5e7c6ca0e653371263d6c24382ea4e173b8d1ccf5b5c5177a052cf50ae0a",
  },
  {
    version: "0.4.0",
    artifactPath: "/agent-setup/releases/0.4.0/delta-adaptive-systems-mockups-0.4.0.tar",
    artifactUrl:
      "https://app.das.dev/agent-setup/releases/0.4.0/delta-adaptive-systems-mockups-0.4.0.tar",
    artifactBytes: 1_202_176,
    artifactSha256: "785613ffd0fb101c6cad1b730b752e4be4bbd217b1172b1d15616ff7aebd1d22",
    manifestPath: "/agent-setup/releases/0.4.0/manifest.json",
    manifestUrl: "https://app.das.dev/agent-setup/releases/0.4.0/manifest.json",
    manifestBytes: 913,
    manifestSha256: "a7ae3b8c8caba3bfa9d43d2ac97e22285972243b4f450e69a3bb72fb3872b415",
  },
  {
    version: "0.3.0",
    artifactPath: "/agent-setup/releases/0.3.0/delta-adaptive-systems-mockups-0.3.0.tar",
    artifactUrl:
      "https://app.das.dev/agent-setup/releases/0.3.0/delta-adaptive-systems-mockups-0.3.0.tar",
    artifactBytes: 1_200_640,
    artifactSha256: "4df429a80fffc725d8e964eb148b847febe1570af43d0cc1628ff9c821c271f9",
    manifestPath: "/agent-setup/releases/0.3.0/manifest.json",
    manifestUrl: "https://app.das.dev/agent-setup/releases/0.3.0/manifest.json",
    manifestBytes: 750,
    manifestSha256: "e8143b8c00f3e131ca0f7a76c16ff5dd0a65cc24d59d4039c915aeccefa75639",
  },
] as const;

export const AGENT_SETUP_RELEASES = [
  AGENT_SETUP_RELEASE,
  ...AGENT_SETUP_RETAINED_RELEASES,
] as const;
